// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1749) return "static/chunks/1749-f2ec4dcfc40558c3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1068":"809f03f9b92968ba","1906":"51f8c38e3be43f5a","5784":"471f3ede72782d0a","6728":"b8ecc9536600c2a0","7278":"9bbb48951d1b9bb4"}[chunkId] + ".js";
};